export const warningTooltipOverlayStyle = {
  maxWidth: "100px",
};
